import { type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

// システムプロンプトを折りたたみ表示するコンポーネント
export function AIAssistantSystemPromptToggle({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const [state, setState] = useState({
    open: false,
  });

  return (
    <>
      {!state.open && (
        <div className="my-1">
          <button
            className="cursor-pointer text-xs text-gray-600 hover:text-gray-700 hover:underline"
            onClick={() => setState((s) => ({ open: !s.open }))}
          >
            {t('viewModel.aiChat.systemPrompt')}
          </button>
        </div>
      )}
      {state.open && (
        <div className="min-h-4 whitespace-pre-wrap rounded border bg-gray-100 p-2 font-mono text-xs text-gray-800">
          <div className="float-end mb-1 ml-1">
            <button
              className="text-xs text-gray-500 underline hover:no-underline"
              onClick={() => setState((s) => ({ open: !s.open }))}
            >
              {t('common.action.close')}
            </button>
          </div>
          {children}
        </div>
      )}
    </>
  );
}
